if (process.env.REACT_APP_APP_ENV === "production") {
  __webpack_public_path__ = process.env.REACT_APP_ASSET_PATH;
}
